// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`34.1|154.38500|82.5|156.03000|82.5|H|N|
34.2|151.32500|136.5|159.31500|000.0|H|N|
34.3|151.05500|192.8|156.04500|192.8|H|N|
34.4|154.83000|186.2|156.09000|186.2|H|N|
34.5|151.02500|82.5|155.55000|000.0|H|N|
34.6|154.17500|88.5|155.88000|000.0|H|N|
34.7|154.14500|82.5|158.77500|000.0|H|N|
34.8|151.02500|82.5|155.55000|000.0|H|N|AKA RIVER CMD
34.9|154.17500|88.5|155.88000|000.0|H|N|AKA BAY CMD
34.10|153.86750|192.8|156.16500|000.0|H|N|NEW MESA FUTURE
34.11|154.14500|82.5|158.77500|000.0|H|N|AKA 5 CITIES
34.12|151.35500|103.5|159.30000|000.0|H|N|LOWE / CALLANDRA
34.13|151.26500|103.5|159.33000|000.0|H|N|LOWE / CALLANDRA / SMITH
34.14|151.16000|192.8|151.16000|192.8|L|N|
34.15|151.17500|192.8|151.17500|192.8|L|N|
34.16|151.34000|192.8|151.34000|192.8|L|N|
34.17|151.37000|192.8|151.37000|192.8|L|N|
34.18|151.22000|192.8|151.22000|192.8|L|N|
34.19|159.26250|192.8|159.26250|192.8|L|N|
34.20|159.36750|192.8|159.36750|192.8|L|N|
34.21|158.92500|192.8|158.92500|192.8|L|N|NEW
34.22|155.37000|192.8|155.37000|192.8|L|N|NEW
34.23|154.34000|192.8|154.34000|192.8|L|N|OLD XSL TAC 4
34.24|153.95000|192.8|153.95000|192.8|L|N|OLD XSL TAC 5
34.25|154.14500|192.8|154.14500|192.8|L|N|OLD XSL TAC 6/CAY TAC
34.26|154.26500|156.7|154.26500|156.7|L|N|
34.27|154.29500|156.7|154.29500|156.7|L|N|
34.28|154.27250|156.7|154.27250|156.7|L|N|
34.29|154.28750|156.7|154.28750|156.7|L|N|
34.30|154.30250|156.7|154.30250|156.7|L|N|
34.31|156.07500|156.7|156.07500|156.7|H|N|
34.32|155.11500|173.8|156.21000|173.8|H|N|
34.33|159.21000|179.9|159.21000|179.9|H|N|
34.34|170.46250|000.0|164.91250|000.0|H|N|
34.35|171.55000|000.0|164.15000|000.0|H|N|
34.36|171.50000|000.0|164.82500|000.0|H|N|
34.37|168.26250|000.0|168.26250|000.0|H|N|
34.38|163.71250|000.0|163.71250|000.0|H|N|
34.39|169.77500|000.0|163.02500|000.0|H|N|CAL VALLEY
34.40|154.43000|82.5|150.77500|110.9|H|N|
34.41|155.11500|82.5|153.81500|82.5|H|N|
34.42|154.23500|82.5|150.80500|110.9|H|N|
34.43|154.19000|82.5|154.19000|82.5|L|N|
34.44|153.96500|82.5|153.96500|82.5|H|N|
34.45|154.37000|131.8|156.15000|146.2|H|N|
34.46|151.10000|131.8|154.07000|146.2|H|N|
34.47|157.57500|192.8|157.57500|192.8|L|N|
34.48|155.07000|162.2|159.04500|162.2|H|N|
34.49|163.53750|100.0|165.06250|000.0|H|N|
34.50|171.70000|000.0|171.70000|000.0|L|N|
34.51|173.20000|000.0|173.20000|000.0|L|N|
34.52|173.55000|000.0|173.55000|000.0|L|N|
34.53|156.00000|146.2|154.10000|146.2|H|N|
34.54|151.16000|146.2|155.95500|103.5|H|N|
34.55|155.89500|D043|158.85000|D025|H|N|
34.56|154.08500|82.5|158.76000|82.5|H|N|
34.57|153.87500|82.5|155.82000|82.5|H|N|
34.58|154.13000|82.5|156.00000|82.5|H|N|
34.59|155.79000|82.5|155.79000|82.5|L|N|
34.60|155.14500|167.9|154.20500|167.9|H|N|
34.61|155.95500|162.2|159.07500|162.2|H|N|
34.62|154.31000|82.5|154.31000|82.5|L|N|
34.63|155.02500|127.3|155.02500|127.3|L|N|
34.64|153.78500|88.5|158.88000|88.5|H|N|
34.65|154.01000|82.5|155.83500|167.9|H|N|
34.66|155.40000|136.5|158.97000|136.5|H|N|
34.67|153.83000|167.9|153.83000|167.9|L|N|
34.68|151.01000|167.9|151.01000|167.9|L|N|
34.69|151.11500|167.9|151.11500|167.9|H|N|
34.70|151.14500|88.5|151.47500|110.9|H|N|
34.71|154.35500|127.3|159.03000|127.3|H|N|
34.72|154.72500|127.3|159.09000|127.3|H|N|
34.73|154.40000|127.3|159.06000|127.3|H|N|
34.74|155.10000|127.3|159.16500|127.3|H|N|GUADALUPE
34.75|150.79000|000.0|150.79000|000.0|L|N|
34.76|156.60000|000.0|156.60000|000.0|L|W|
34.77|155.74500|82.5|158.89500|146.2|H|N|
34.78|168.62500|000.0|168.62500|110.9|L|N|Emergency
35.1|151.44500|146.2|159.39000|000.0|H|N|
35.2|151.32500|146.2|159.31500|000.0|H|N|
35.3|151.25000|146.2|159.40500|000.0|H|N|
35.4|151.35500|103.5|159.30000|000.0|H|N|
35.5|151.26500|103.5|159.33000|000.0|H|N|
35.6|151.34000|103.5|159.34500|000.0|H|N|
35.7|151.17500|192.8|151.17500|192.8|L|N|
35.8|151.25000|192.8|151.25000|192.8|L|N|
35.9|151.37000|192.8|151.37000|192.8|L|N|
35.10|151.22000|192.8|151.22000|192.8|L|N|
35.11|159.26250|192.8|159.26250|192.8|L|N|
35.12|159.36750|192.8|159.36750|192.8|L|N|
35.13|154.28000|156.7|154.28000|156.7|H|N|
35.14|154.26500|156.7|154.26500|156.7|L|N|
35.15|154.29500|156.7|154.29500|156.7|L|N|
35.16|154.27250|156.7|154.27250|156.7|L|N|
35.17|154.28750|156.7|154.28750|156.7|L|N|
35.18|154.30250|156.7|154.30250|156.7|L|N|
35.19|151.13750|156.7|151.13750|156.7|L|N|
35.20|154.45250|156.7|154.45250|156.7|L|N|
35.21|158.73750|156.7|158.73750|156.7|L|N|
35.22|159.47250|156.7|159.47250|156.7|L|N|
35.23|156.07500|156.7|156.07500|156.7|H|N|
35.24|151.14500|156.7|154.05500|OST|H|N|T-6 Chino Hills, T-7 Rodman Mtn
35.25|159.12000|167.9|156.06000|OST|H|N|T1-Donnell Hill, T2-El Paso Mtns, T6-San Sevaine
35.26|151.15250|167.9|158.88750|OST|H|N|T2-Trona, T7 Quartzite
35.27|154.03250|91.5|155.91750|OST|H|N|Yucca/29 Palms, T-6 Onyx Pk
35.28|155.10750|91.5|155.97000|OST|H|N|T1-Paxton Hill, T5-Spirit Mtn, T-6 Big Bear
35.29|154.38500|167.9|151.47500|OST|H|N|T2-Flash II, T7-Little Mountain
35.30|154.19000|167.9|154.83750|OST|H|N|T-7 Heaps Peak
35.31|153.83000|167.9|153.83000|167.9|L|N|San Bernardino Countywide Tac
35.32|154.73250|167.9|154.73250|167.9|L|N|San Bernardino Countywide Tac
35.33|154.07000|167.9|154.07000|167.9|L|N|San Bernardino Countywide Tac
35.34|155.40750|167.9|155.40750|167.9|L|N|San Bernardino Countywide Tac
35.35|154.32500|167.9|154.32500|167.9|L|N|San Bernardino Countywide Tac
35.36|155.40000|167.9|155.40000|167.9|L|N|San Bernardino Countywide Tac
35.37|155.11500|146.2|155.11500|146.2|L|N|Handcrew logistics only
35.38|153.96500|167.9|153.96500|167.9|L|N|
35.39|154.20500|167.9|154.20500|167.9|L|N|Apple Valley VHF Tac
35.40|155.36250|167.9|153.85250|167.9|H|N|Bertha Pk/Big Bear
35.41|154.02500|167.9|154.02500|167.9|L|N|Ontario FD Dispatch
35.42|153.77000|156.7|153.77000|156.7|L|N|
35.43|172.37500|000.0|164.9375|000.0|H|N|
35.44|171.47500|000.0|168.1500|000.0|H|N|
35.45|172.22500|000.0|164.1375|000.0|H|N|
35.46|171.4250|103.5|164.8000|000.0|H|N|
35.47|170.52500|000.0|164.18750|000.0|H|N|(Toiyabe) Bridgeport ranger dist
35.48|173.80000|000.0|165.01250|000.0|H|N|FS INF N Fall 2018
35.49|173.83750|000.0|166.26250|000.0|H|N|
35.50|169.71250|000.0|163.12500|000.0|H|N|
35.51|166.37500|000.0|166.97500|000.0|H|N|
35.52|171.67500|000.0|166.27500|141.3|H|N|
35.53|168.05000|000.0|168.05000|000.0|L|N|
35.54|168.20000|000.0|168.20000|000.0|L|N|
35.55|168.60000|000.0|168.60000|000.0|L|N|
35.56|168.63750|000.0|168.63750|000.0|L|N|
35.57|167.47500|000.0|167.47500|000.0|L|N|
35.58|168.48750|000.0|168.48750|000.0|L|N|
35.59|169.11250|000.0|169.11250|000.0|L|N|
35.60|154.43000|000.0|154.43000|000.0|H|N|
35.61|153.87500|000.0|155.88000|000.0|H|N|
35.62|154.31000|000.0|155.86500|000.0|H|N|Tone 3, 4, 13 & 14
35.63|154.37750|000.0|159.00000|000.0|H|N|Tone 3, 4, 13 & 14
35.64|154.22000|000.0|158.93250|000.0|H|N|Tone 1 & 2
35.65|154.14500|000.0|154.14500|000.0|L|N|
35.66|154.37000|000.0|154.37000|000.0|L|N|
35.67|153.86000|000.0|155.76000|000.0|H|N|
35.68|151.11500|000.0|159.18000|000.0|H|N|
35.69|151.08500|000.0|159.15000|000.0|H|N|
35.70|159.18000|000.0|159.18000|000.0|L|N|
35.71|159.15000|000.0|159.15000|000.0|L|N|
35.72|154.34000|000.0|154.34000|000.0|L|N|
35.73|154.72500|000.0|000.00000|000.0||N|RX ONLY for non-LE load
35.74|155.53500|000.0|000.00000|000.0||N|INYO CO. SO 1 Car to Car
35.75|155.85000|000.0|000.00000|000.0||N|INYO CO SO JAIL/TAC
35.76|156.07500|000.0|000.00000|000.0||N|INYO CO SO BLUE
35.77|155.47500|000.0|000.00000|000.0||N|INYO CO SO GREY
35.78|151.02500|000.0|000.00000|000.0||N|INYO CO. SO 2
35.79|154.87500|000.0|000.00000|000.0||N|BISHOP PD
35.80|155.01000|000.0|000.00000|000.0||N|BISHOP PD C/C
35.81|156.15000|000.0|000.00000|000.0||N|BISHOP PD TAC
35.82|154.80000|000.0|000.00000|000.0||N|MONO CO. SO (CAR TO CAR)
35.83|154.80000|000.0|000.00000|000.0||N|MONO CO. SO Caso Diablo
35.84|155.59500|000.0|000.00000|000.0||N|MAMMOTH PD
35.85|155.59500|000.0|000.00000|000.0||N|MAMMOTH PD (CAR TO CAR)
35.86|155.55000|000.0|000.00000|000.0||N|MAMMOTH PD (TACTICAL)
35.87|170.10000|000.0|000.00000|000.0||N|RX ONLY for non-LE load
35.88|169.98750|000.0|000.00000|000.0||N|RX ONLY for non-LE load
35.89|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
